import { VERSION as deckGlVersion } from '@deck.gl/core'

import { MVTWorkerLoader } from '@loaders.gl/mvt'

// all .version properties in loaders.gl/.. workers are offset by one
//   https://github.com/visgl/loaders.gl/issues/3202
// mark them here until we can rely on those version
const mvtWorkerLoaderVersion = `quirk-${MVTWorkerLoader.version}`

export const deckWorkersDir = `workers/deck.gl@${deckGlVersion}`
export const mvtWorkerDir = `workers/loaders.gl/mvt@${mvtWorkerLoaderVersion}`

function getLocalDeckWorkerUrl(workerScriptName: string, baseDir: string) {
  return `/${baseDir}/${workerScriptName}-worker.js`
}

function getLocalDeckCartoWorkerLoaderOptions(workerScriptName: string, baseDir: string) {
  return {
    [workerScriptName]: {
      workerUrl: getLocalDeckWorkerUrl(workerScriptName, baseDir)
    }
  }
}

export const cartoVectorTileLoadOptions = {
  ...getLocalDeckCartoWorkerLoaderOptions('cartoVectorTile', deckWorkersDir),
  ...getLocalDeckCartoWorkerLoaderOptions('mvt', mvtWorkerDir)
}

export const cartoSpatialTileLoadOptions = getLocalDeckCartoWorkerLoaderOptions('cartoSpatialTile', deckWorkersDir)
export const cartoRasterTileLoadOptions = getLocalDeckCartoWorkerLoaderOptions('cartoRasterTile', deckWorkersDir)

export async function fetchWorkerScriptAsBlobUrl(url: string | URL): Promise<string> {
  const response = await fetch(url)
  const blob = await response.blob()
  return URL.createObjectURL(blob)
}

export async function preloadWorkerScriptsAsBlobs() {
  async function fetchWorkerScriptAsBlobUrl(url: string | URL): Promise<string> {
    const response = await fetch(url)
    const blob = await response.blob()
    return URL.createObjectURL(blob)
  }

  await Promise.all([
    fetchWorkerScriptAsBlobUrl(cartoVectorTileLoadOptions.cartoVectorTile.workerUrl).then((url) => {
      cartoVectorTileLoadOptions.cartoVectorTile.workerUrl = url
    }),
    fetchWorkerScriptAsBlobUrl(cartoVectorTileLoadOptions.mvt.workerUrl).then((url) => {
      cartoVectorTileLoadOptions.mvt.workerUrl = url
    }),
    fetchWorkerScriptAsBlobUrl(cartoSpatialTileLoadOptions.cartoSpatialTile.workerUrl).then((url) => {
      cartoSpatialTileLoadOptions.cartoSpatialTile.workerUrl = url
    }),
    fetchWorkerScriptAsBlobUrl(cartoRasterTileLoadOptions.cartoRasterTile.workerUrl).then((url) => {
      cartoRasterTileLoadOptions.cartoRasterTile.workerUrl = url
    })
  ])
}
